import config from "@/utils/config";
import ApiHelper from "@/utils/api/ApiHelper";
export default class DemoProviderApi extends ApiHelper{
    static buildUrl(url:string):string{
        if(config.isCloud)url=config.modelTypes.demoProvider+url;
        return url;
    }
}